import { ReactChild, ReactChildren, useEffect, useState } from 'react';

import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';

import { Box, IconButton, Typography } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

const ArrowNavigationStyles = styled.div`
  display: inline-flex;
  align-self: flex-end;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
  }

  .cnt-box {
    min-width: 36px;
    text-align: center;
  }
`;

type Props<T> = {
  onNavigate: (direction: 'prev' | 'next', index: number) => void;
  options: T[];
  selectedOption: T;
  disabled?: boolean;
  showCnt?: boolean;
  shouldHideArrows?: boolean;
  children?: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
};

export default function ArrowNavigation<T>({
  onNavigate,
  options,
  selectedOption,
  disabled = false,
  showCnt,
  children,
  shouldHideArrows = false
}: Props<T>) {
  const [isPrevDisabled, setPrevDisabled] = useState(true);
  const [isNextDisabled, setNextDisabled] = useState(false);

  useEffect(() => {
    const index = options.indexOf(selectedOption);
    setPrevDisabled(index === 0 || index === -1);
    setNextDisabled(index === options.length - 1);
  }, [options, selectedOption]);

  return (
    <ArrowNavigationStyles className="arrow-navigation">
      {!shouldHideArrows && (
        <IconButton
          onClick={() =>
            onNavigate(
              'prev',
              selectedOption ? options.indexOf(selectedOption) : 1
            )
          }
          color="primary"
          disabled={disabled || isPrevDisabled}
          size="small"
        >
          <FontAwesomeSvgIcon icon={faChevronLeft} fontSize="small" />
        </IconButton>
      )}
      {showCnt && (
        <Typography
          className="d-flex v-center h-center cnt-box"
          variant="subtitle2"
          component="span"
        >
          {options.length && (
            <>
              {options.indexOf(selectedOption) + 1} /{options.length}
            </>
          )}
        </Typography>
      )}
      {children && <Box px={2}>{children}</Box>}
      {!shouldHideArrows && (
        <IconButton
          onClick={() =>
            onNavigate(
              'next',
              selectedOption ? options.indexOf(selectedOption) : 1
            )
          }
          color="primary"
          disabled={disabled || isNextDisabled}
          size="small"
        >
          <FontAwesomeSvgIcon icon={faChevronRight} fontSize="small" />
        </IconButton>
      )}
    </ArrowNavigationStyles>
  );
}
